<template>
    <div class="m-c-list-item">
        <dl class="m-c-list-item__content">
            <!-- TODO - place project link on each project row (href="`${project.url}`") -->
            <div class="m-c-list-item__col">
                <dd>
                    <a
                        class="m-c-list-item__link"
                        :href="`${getItemSingleBaseUrl() + project.url}`"
                    >
                        <span class="m-c-list-item__legend"
                            >{{ $t.message("project") }}:</span
                        >
                        <span> {{ project.title }}</span>
                    </a>
                </dd>
            </div>
            <div class="m-c-list-item__col">
                <dd>
                    <span aria-hidden="false" class="m-c-list-item__legend"
                        >{{ $t.message("grantee") }}:</span
                    >
                    {{ project.organisation }}
                </dd>
            </div>
            <div class="m-c-list-item__col">
                <dd>
                    <span aria-hidden="false" class="m-c-list-item__legend"
                        >{{ $t.message("destinationCountry") }}:</span
                    >
                    <template v-for="(country, index) in project.countries">
                        <span
                            v-if="index < project.countries.length - 1"
                            :key="country.id"
                        >
                            {{ country.label }},
                        </span>
                        <span v-else :key="country.id">
                            {{ country.label }}
                        </span>
                    </template>
                </dd>
            </div>
            <div class="m-c-list-item__col">
                <dd>
                    <span aria-hidden="false" class="m-c-list-item__legend"
                        >{{ $t.message("topic") }}:</span
                    >
                    <template v-for="(topic, index) in project.topics">
                        <span
                            v-if="index < project.topics.length - 1"
                            :key="topic.id"
                        >
                            {{ topic.label }},
                        </span>
                        <span v-else :key="topic.id">
                            {{ topic.label }}
                        </span>
                    </template>
                </dd>
            </div>
            <div class="m-c-list-item__col">
                <dd>
                    <span aria-hidden="false" class="m-c-list-item__legend"
                        >{{ $t.message("status") }}:</span
                    >
                    {{ formatStatus(project.status[0].id) }}
                </dd>
            </div>
        </dl>
    </div>
</template>

<script>
import Mixins from "./component.mixins";

export default {
    name: "ListItem",
    // mixins
    mixins: [Mixins],
    // component props
    props: ["projectData"],
    // component data
    data() {
        return {
            project: this.projectData,
        };
    },
    methods: {
        formatDate(dateStr) {
            const date = new Date(dateStr * 1000);
            if (isNaN(date.getDate())) {
                return dateStr;
            }
            return `${date.getDate()}.${date.getMonth()}.${date.getFullYear()}`;
        },
        formatAmount(amount) {
            return new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR",
            }).format(amount);
        },
        formatStatus(status) {
            return status === 2
                ? this.$t.message("statusCompleted")
                : this.$t.message("statusOngoing");
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
